import { useEffect, useRef } from "react";
import { Niivue } from "@niivue/niivue";

export default function ObjViewerNiivue({ brainUrl, lesionUrl }) {
  const canvasRef = useRef(null);
  const nvRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    const nv = new Niivue({
      dragMode: 3, // orbit
      show3D: true, // 3-D pane only
      backColor: [0.11, 0.11, 0.11, 1],
      autoRotate: true, // gentle spin
      rotateSpeed: 0.002, // rad / frame
    });

    nv.attachToCanvas(canvasRef.current);

    const layers = [];
    // if (brainUrl) layers.push({ url: brainUrl, color: [0.63, 0.77, 1, 1] });
    if (brainUrl)
      layers.push({
        url: brainUrl,
        rgba255: [160, 180, 255, 255], // blue
        opacity: 0.9,
      });

    if (lesionUrl)
      layers.push({
        url: lesionUrl,
        rgba255: [255, 120, 120, 255], // red
        opacity: 1.0,
      });
    // nv.loadMeshes(layers).then(() => nv.setAutoRotate(true));
    nv.loadMeshes(layers);

    nvRef.current = nv;
    return () => nv.cleanup();
  }, [brainUrl, lesionUrl]);

  const hasAny = Boolean(brainUrl || lesionUrl);
  if (!hasAny) {
    return (
      <div className="brain-viewer-placeholder">
        <div className="placeholder-content">
          <div className="placeholder-icon">🧠</div>
          <h4>3D Mesh Viewer</h4>
          <p>No 3-D mesh available for this scan</p>
        </div>
      </div>
    );
  }

  /* same outer box we added earlier – keeps sizing identical */
  return (
    <div className="obj-viewer-box" style={{ borderRadius: "20px", width: "100%" }}>
      <canvas ref={canvasRef} style={{ width: "100%", height: "100%", display: "block" }} />
    </div>
  );
}
